import AboutPage from "../components/about-page/about-page.component"

const About = () => (
    <div style={{maxWidth: "calc(1630px + 15vw)", margin: "auto"}}>
        <AboutPage />
    </div>
)

export default About;